import { all, call, put, takeLatest } from "redux-saga/effects";
import { apiGetCall, apiPostCall } from "../api";
import { getAllRegistrationData, setAllRegistrationData } from "../slices/sellerRegSlice";
import { submitRequest, submitSuccess, submitFailure } from "../slices/sellerRegSlice";

const SELLER_REGISTRATION_URL = process.env.REACT_APP_SELLER_REGISTRATION_FORM_URL


function* getAllRegistrationDataSaga() {
    try {
        const data = yield call(apiGetCall, SELLER_REGISTRATION_URL + 'registration', {
            headers: {
                Authorization: undefined
            }
        })
        yield put(setAllRegistrationData(data));
    } catch (error: any) {
        console.log("get formdata err:", error.message)
    }
}

const updatePOS = (postData) => {
    const pos =
        postData["pos_preference"] && postData["pos_preference"].length !== 0
            ? postData["pos_preference"].map((pos) => pos.split(" ").pop())
            : []
    const posOther =
        postData["pos_preference_other"] && postData["pos_preference_other"].length !== 0
            ? postData["pos_preference_other"].map((pos) => pos.split(" ").pop())
            : []
    const posPreference = pos.length || posOther.length ? [...pos, ...posOther] : ["None"];
    return {
        "pos_preference": posPreference,
    }
}

function* submitSellerRegistrationSaga(action: any) {
    try {
        const postData = action.payload;
        
        if (postData["implementation_start_date"] instanceof Date) {
            postData["implementation_start_date"] = postData["implementation_start_date"].toISOString();
        }

        const data = {
            ...postData,
            ...(postData["implementation_start_date"] && { "implementation_start_date": postData["implementation_start_date"] }),
            ...(updatePOS(postData)),
            ...(postData["api_schema_version"] && { "api_schema_version": [postData["api_schema_version"]] }),
            ...(postData["customer_type"] && { "customer_type": postData.CustomerTypeIDs[postData["customer_type"]] }),
            ...(postData["business_model_type"] && { "business_model_type":  (() => {
                let bizModels: string[] = [];        
                const businessModelType = Array.isArray(postData["business_model_type"]) 
                ? postData["business_model_type"] 
                : [postData["business_model_type"]]; 
    
            businessModelType.forEach((value) => {
                if (postData.BusinessModelIDs[value]) {
                    bizModels.push(postData.BusinessModelIDs[value]);
                }
            });
                return bizModels;
              })() }),
            // ...(postData["iata_number"] && { "iata_number": postData["iata_number"] }),
            "pos_enabled": "1",
        };
        
        const response = yield call(apiPostCall, SELLER_REGISTRATION_URL + 'register', data);
        if (response) {
            yield put(submitSuccess());
        } else {
            yield put(submitFailure('Submission failed'));
        }
    } catch (error: any) {
        console.log("submitSellerRegistrationSaga error:", error.message);
        yield put(submitFailure(error.message));
    }
}


function* sagas() {
    yield all([
        takeLatest(getAllRegistrationData.type, getAllRegistrationDataSaga),
        takeLatest(submitRequest.type, submitSellerRegistrationSaga),

    ]);
}

export default sagas

